import { t } from 'shared/locale/texts';
import type { FhhState } from '../../../fhh/fhhDefaultState';

export const formatBedroomText = (state: FhhState): string => {
    const bedText = state.numOfBeds ? t('fhh.bed', { count: state.numOfBeds }) : t('fhh.bed_all');

    const bedroomText = state.numOfBedrooms ? t('fhh.bedroom', { count: state.numOfBedrooms }) : t('fhh.bedroom_all');

    return `${bedText}, ${bedroomText}`;
};
